import apiProvider from './provider';
import * as JSZip from 'jszip';
import {
  BOOKING_FETCH_ALL_SHIPPER,
  BOOKING_FETCH_ALL_FF,
  BOOKING_CONFIRM,
  BOOKING_CREATE,
  BOOKING_DECLINE,
  BOOKING_PENDING_COUNT,
  BOOKING_FETCH_CHARGE_DETAILS,
  BOOKING_FETCH_BOOKING_DETAILS,
  BOOKING_BID_BREAKDOWN,
  BOOKING_SEARCH,
  BOOKING_GET_BOOKING_STAT,
  BOOKING_BID_RANKS_FOR_BOOKING,
  FETCH_ALL_BIDS_FOR_BOOKING,
  BOOKING_MIS_REPORTS,
  BOOKING_FETCH_STATUS_WISE_COUNT_FOR_BOOKINGS,
  EXTRACT_DO_DETAILS,
  CREATE_INTTRA_BOOKING,
  CANCEL_INTTRA_BOOKING_REQUEST,
  AMEND_INTTRA_BOOKING_REQUEST,
  REQUEST_INTTRA_REGISTRATION_EMAIL,
  FETCH_LOCATION,
  CREATE_SPLIT_BOOKINGS,
  FETCH_SPLIT_BOOKING_DETAILS,
  NOTIFY_USERS_BOOKING,
  BOOKING_VIEW_PURCHASE_ORDER,
} from './routes';
import { getAuthenticationHeaders, getErrorMessage } from './utils';
import { downloadFileData, downloadS3Url } from '../utils/utils';
import { API_BASE_URL } from 'src/globals';
import { APIResponseType } from 'src/Library/Types';
import { FetchBookingDetailsData } from 'src/dto/response/fetchBookingDetails';
import { FetchBookingBreakdownData } from 'src/dto/response/fetchBookingBreakdown';
import { POST, GET, PATCH, ApiResponseWrapper } from './apiHandler';
import { message } from 'antd';
import { AxiosResponse, CancelTokenSource } from 'axios';

export const fetchAllBookingShipper = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${BOOKING_FETCH_ALL_SHIPPER}`, body, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchAllBookingFF = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${BOOKING_FETCH_ALL_FF}`, body, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchBookingInquiryStatusWiseCountForShipper = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${BOOKING_FETCH_STATUS_WISE_COUNT_FOR_BOOKINGS}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchBookingInquiryStatusWiseCountForFF = async (params) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${BOOKING_FETCH_STATUS_WISE_COUNT_FOR_BOOKINGS}`,
      params,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const createBooking = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${BOOKING_CREATE}`, body, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const confirmBooking = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${BOOKING_CONFIRM}`, body, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const declineBooking = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${BOOKING_DECLINE}`, body, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const bookingPendingCount = async (params) => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(`${API_BASE_URL}${BOOKING_PENDING_COUNT}`, {
      params,
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const searchBookingApi = async (params, source?: CancelTokenSource) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${BOOKING_SEARCH}`, params, {
      headers: getAuthenticationHeaders(),
      ...(source ? { cancelToken: source.token } : {}),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const getBookingChargeDetails = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${BOOKING_FETCH_CHARGE_DETAILS}`,
      body,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const fetchBookingDetail = async (params): Promise<APIResponseType<FetchBookingDetailsData>> => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<FetchBookingDetailsData>> = await apiProvider.get(`${API_BASE_URL}${BOOKING_FETCH_BOOKING_DETAILS}`, {
      params,
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const downloadBookingPurchaseOrder = async (params) => {
  return POST(
    `${API_BASE_URL}${BOOKING_VIEW_PURCHASE_ORDER}`,
    params,
    getAuthenticationHeaders(),
    true
  );
};
export const fetchBookingBreakdown = async (params: { bookingId: string }): Promise<APIResponseType<FetchBookingBreakdownData>> => {
  try {
    const response: AxiosResponse<ApiResponseWrapper<FetchBookingBreakdownData>> = await apiProvider.get(`${API_BASE_URL}${BOOKING_BID_BREAKDOWN}`, {
      params,
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const getBookingStat = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${BOOKING_GET_BOOKING_STAT}`, body, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const getBidRanksForBooking = async (body) => {
  try {
    const response = await apiProvider.post(
      `${API_BASE_URL}${BOOKING_BID_RANKS_FOR_BOOKING}`,
      body,
      { headers: getAuthenticationHeaders() }
    );
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const fetchAllBidsForBooking = async (body) => {
  try {
    const response = await apiProvider.post(`${API_BASE_URL}${FETCH_ALL_BIDS_FOR_BOOKING}`, body, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      data: response.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
export const getBookingMISReport = async () => {
  try {
    const response: AxiosResponse<ApiResponseWrapper> = await apiProvider.get(`${API_BASE_URL}${BOOKING_MIS_REPORTS}`, {
      headers: getAuthenticationHeaders(),
    });
    return {
      isSuccess: true,
      response: response.data.data,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};

export const convertBookingNotesToZip = (cardData) => {
  const documents = cardData?.confirmationDetails?.documents?.filter((item) => item.type === 'DO');
  if (!documents?.length) {
    message.error('No documents found');
    return;
  }
  if (documents?.length > 1) {
    const zip = new JSZip();
    let index = 0;
    documents.forEach((doc) => {
        fetch(doc.url).then(response => {
          if (response.status === 200) {
            zip.file(doc.url.substring(doc.url.lastIndexOf('/') + 1), response.blob());
          }
        }).finally(()=> {
          index += 1;
          if (documents.length === index) {
            const bookingNumber = cardData.bookingNumber || cardData?.bookingDetails?.bookingNumber;
            zip.generateAsync({type: "blob"}).then(function(content) {
              downloadFileData(content, `${bookingNumber}.zip`, true);
            });
          }
        });
    });
  } else if (documents?.length === 1) {
    downloadS3Url(documents[0].url, documents[0].url.substring(documents[0].url.lastIndexOf('/') + 1));
  }
}

export const extractDODetails = async (params) => {
  return POST(`${API_BASE_URL}${EXTRACT_DO_DETAILS}`, params);
};

export const createInttraBooking = async (params) => {
  return POST(`${API_BASE_URL}${CREATE_INTTRA_BOOKING}`, params);
};

export const cancelInttraBookingRequest = async (params) => {
  return POST(`${API_BASE_URL}${CANCEL_INTTRA_BOOKING_REQUEST}`, params);
};

export const amendInttraBookingRequest = async (params) => {
  return POST(`${API_BASE_URL}${AMEND_INTTRA_BOOKING_REQUEST}`, params);
};

export const requestInttraRegistrationEmail = async () => {
  return POST(`${API_BASE_URL}${REQUEST_INTTRA_REGISTRATION_EMAIL}`, {});
};

export const fetchLocation = async (queryString) => {
  return GET(`${API_BASE_URL}${FETCH_LOCATION}`, queryString);
};

export const createSplitBookings = async (bookingId) => {
  return POST(`${API_BASE_URL}${CREATE_SPLIT_BOOKINGS}/${bookingId}`, {});
};

export const fetchSplitBookingDetails = async (bookingId) => {
  return GET(`${API_BASE_URL}${FETCH_SPLIT_BOOKING_DETAILS}/${bookingId}`);
};

export const updateBookingAccessType = async (body) => {
  return PATCH(`${API_BASE_URL}/booking`, body);
};

export const notifyBookingUsers = async (body) => {
  return POST(`${API_BASE_URL}${NOTIFY_USERS_BOOKING}`, body);
};
